import { useAppSelector } from 'store/store';

type UseExternalServiceResponse = {
    showOnlyExternalService: boolean;
};

export const useExternalService = (): UseExternalServiceResponse => {
    const showOnlyExternalService = useAppSelector(state => state.externalService?.showOnly) || false;

    return {
        showOnlyExternalService,
    };
};
